module.exports = __webpack_public_path__ + "static/media/nina.453731e5.png";